import template from '../views/extended-duplicates-list.tpl.html';

export default {
    slug: 'contacts',
    type: 'contacts-duplicates',
    title: 'Contact Duplicates',
    visible: [
        // 'first_name',
        // 'last_name',
        // 'email'
    ],
    listview: 'ContactsDuplicatesListView',
    toolsetTemplate: 'asd',
    locales: ['common'],
    extendedListView: true,
    extendedListViewTemplate: template,
    extendedListController: 'RsvpsDuplicatesExtendedListViewCtrl',
    view: {
        mode: 'duplicatesview'
    },
    identifier_field: 'duplicate_information.identifier',
    permanentFields: [],
    templates: {
        'full_name'(row) {
            return row.full_name + (row.has_child ? ' <i class="fal fa-users"></i>' : '');
        }
    },
    actions: {},
    copyColumns: [
        'code',
        'full_name',
        'email',
        'business_email',
        'preferred_email',
        'cc_email',
        'web',
        'last_message_subject',
        'last_message_state_information'
    ],
    tooltipColumns: [
        'last_message.subject',
        'last_message.extended_information'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/contacts/duplicates/state.js